import { SiteConfig } from "../../types";

export const _config: SiteConfig = {
  isDefault: false,
  showTidio: false,
  enableStripeBilling: false,
  publicUrl: "https://app.konusio.ai",
  serviceName: "Konuşio AI",
  pwaServiceName: "Konuşio AI",
  appLogoPath: "/partner/konusio/logo.png",
  appLogoHeight: "60px",
  landingLogoPath: "/partner/konusio/logo.png",
  landingLogoHeight: "60px",
  hubLogoPath: "/partner/konusio/logo.png",
  hubLogoHeight: "60px",
  favicon: "/partner/konusio/icon.png",
  pwaIcons: [
    {
      src: "/partner/konusio/icon.png",
      type: "image/png",
      sizes: "192x192",
    },
  ],
  overrideLanding: true,
  emailsSender: "info@lang-services.com",
  adminEmail: "ibrahim.ege@gmail.com",
  reviewLink: null,
  copyright: "Konuşio AI",
  showLanguageGuides: true,
  enableRecordingPlayback: true,
  bioPrompt: `
    You are a tutor at Konuşio AI.
  `,
  siteColors: {
    special: {
      desktopSidebar: "#111",
      desktopSidebarBorderColor: "#222",
      desktopSidebarText: "#fff",
      desktopSidebarTextHover: "#555",
      chatAsideMenu: "#333",
      mobileNavBackgroundColor: "#333",
      mobileNavBackgroundContrastColor: "#ffffff",
      mobileNavBorderColor: "#333",
      speakInputIdle: "var(--chakra-colors-brand-tertiary-500)",
      speakInputRecording: "var(--chakra-colors-brand-tertiary-800)",
      speakInputRecordingCancel: "var(--chakra-colors-brand-tertiary-900)",
    },
  },
  colors: {
    primary: {
      main: "#f2ab27",
      mainContrast: "#000",
      "50": "#fef7e9",
      "100": "#fadda7",
      "200": "#f5bc54",
      "300": "#da9a23",
      "400": "#c3891f",
      "500": "#a4741a",
      "600": "#8a6216",
      "700": "#6f4f12",
      "800": "#5e420f",
      "900": "#44300b",
    },
    secondary: {
      main: "#f2ab27",
      mainContrast: "#000",
      "50": "#fef7e9",
      "100": "#fadda7",
      "200": "#f5bc54",
      "300": "#da9a23",
      "400": "#c3891f",
      "500": "#a4741a",
      "600": "#8a6216",
      "700": "#6f4f12",
      "800": "#5e420f",
      "900": "#44300b",
    },
    tertiary: {
      main: "#f2ab27",
      mainContrast: "#000",
      "50": "#fef7e9",
      "100": "#fadda7",
      "200": "#f5bc54",
      "300": "#da9a23",
      "400": "#c3891f",
      "500": "#a4741a",
      "600": "#8a6216",
      "700": "#6f4f12",
      "800": "#5e420f",
      "900": "#44300b",
    },
  },
};
